import { notesStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaNotes";
import { checkoutBlockSubTitleStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(notesStyles, {
    wrapper: {
        css: css`
            padding-bottom: 20px;
        `,
    },
    notesTextArea: {
        cssOverrides: {
            formField: css`
                label {
                    ${checkoutBlockSubTitleStyles()}
                }
            `,
        },
    },
});
